###
  CRUD Sites widget
###

class INTENT.widgets.CrudSite

  @ATTR_NAME: "data-widget-crud-site"
  @ATTR_JSON: "#{@ATTR_NAME}-json"
  @ATTR_VALUES: "#{@ATTR_NAME}-values"
  @ATTR_CPA_CONTROLS: "#{@ATTR_NAME}-enable-cpa-controls"

  @CLASS_ERROR: "error-input-field"

  @ATTR_ANALYTICS: "#{@ATTR_NAME}-analytics"
  @ATTR_ANALYTICS_AUTH: "#{@ATTR_ANALYTICS}-auth"
  @ATTR_ANALYTICS_SOURCE: "#{@ATTR_ANALYTICS}-source"
  @ATTR_ANALYTICS_ADVERTISER: "#{@ATTR_ANALYTICS}-advertiser"
  @ATTR_ANALYTICS_SITE: "#{@ATTR_ANALYTICS}-site"
  @ATTR_ANALYTICS_METHOD: "#{@ATTR_ANALYTICS}-method"

  @ATTR_RULE: "#{@ATTR_NAME}-rule"
  @ATTR_RULE_ADD: "#{@ATTR_RULE}-add"
  @ATTR_RULE_REMOVE: "#{@ATTR_RULE}-remove"
  @ATTR_RULE_TYPES: "#{@ATTR_RULE}-types"
  @ATTR_RULE_NAME: "#{@ATTR_RULE}-name"
  @ATTR_RULE_MAX_CONVERSIONS_NUMBER: "#{@ATTR_RULE}-max_conversions_number"
  @ATTR_RULE_ID: "#{@ATTR_RULE}-id"
  @ATTR_RULE_ADDITIONAL: "#{@ATTR_RULE}-additional"
  @ATTR_RULE_ADDITIONAL_FIELD: "#{@ATTR_RULE_ADDITIONAL}-field"
  @ATTR_RULE_CONTAINER: "#{@ATTR_RULE}-container"

  @ATTR_GET_ORD_FEED_PRODUCT_STATUSES: "#{@ATTR_NAME}-get-ord-feed-statuses"
  @ATTR_GET_BLOCK_FOR_PRODUCT_STATUSES: "#{@ATTR_NAME}-block-for-ord-feed-statuses"
  @ATTR_GET_BLOCK_FOR_PRODUCT_STATUSES_LOADING: "#{@ATTR_NAME}-get-ord-feed-statuses-loading"
  @ATTR_GET_ORD_FEED_PRODUCT_STATUSES_SITE: "#{@ATTR_GET_ORD_FEED_PRODUCT_STATUSES}-site"

  constructor: (@el) ->
    @s = @.constructor

    @form = @el.find "form"

    @analytics_auth_btn = @el.find "[#{@s.ATTR_ANALYTICS_AUTH}]"
    @analytics_source = @el.find "[#{@s.ATTR_ANALYTICS_SOURCE}]"
    @analytics_advertiser = @analytics_auth_btn.attr(@s.ATTR_ANALYTICS_ADVERTISER)
    @analytics_site = @analytics_auth_btn.attr(@s.ATTR_ANALYTICS_SITE)
    @analytics_method = @analytics_auth_btn.attr(@s.ATTR_ANALYTICS_METHOD)

    @rules_add = @el.find "[#{@s.ATTR_RULE_ADD}]"
    @rules_container = @el.find "[#{@s.ATTR_RULE_CONTAINER}]"
    @rules_container.on "click", "[#{@s.ATTR_RULE_REMOVE}]", @remove_item

    @rules_add.on "click", @add_item
    @rules_container.on "change", "[#{@s.ATTR_RULE_TYPES}]", @change_type

    @analytics_auth_btn.on "click", @analytics_auth

    @get_ord_feed_product_statuses = @el.find "[#{@s.ATTR_GET_ORD_FEED_PRODUCT_STATUSES}]"
    @get_ord_feed_product_statuses_site = @get_ord_feed_product_statuses.attr(@s.ATTR_GET_ORD_FEED_PRODUCT_STATUSES_SITE)
    @get_ord_feed_product_statuses_block = @el.find "[#{@s.ATTR_GET_BLOCK_FOR_PRODUCT_STATUSES}]"
    @get_ord_feed_product_statuses_loading = @el.find "[#{@s.ATTR_GET_BLOCK_FOR_PRODUCT_STATUSES_LOADING}]"
    @get_ord_feed_product_statuses.on "click", @get_ord_feed_product_statuses_func

    $('.submit-button') .on 'click',  (e) =>
      @btnSubmit = $(e.target)
      @prevalidate_convertion_rules()

    $(document).on 'change', '.deduplication-window', (e) =>
      input = $(e.target).parents('.select2-input-group').find('input')
      disabled = if $(e.target).val() is 'disabled' then true else false
      input.attr('disabled': disabled)

    $('#predictor-start-date').datetimepicker
      format: "YYYY-MM-DD"

    $(document).on 'switchChange.bootstrapSwitch', '.build-cpa-model', (e) =>
      if $('.build-cpa-model:checked').length > 2
        $(e.target).bootstrapSwitch('state', false)
        INTENT.utils.Notify.error __('sites.conversion_rules.table.build_cpa_model.error.message')

    @init_exist()

  get_ord_feed_product_statuses_func: =>
    @get_ord_feed_product_statuses_loading.css({display:'block'})
    @get_ord_feed_product_statuses.css({display:'none'})
    @get_ord_feed_product_statuses_block.html ''
    error_html = '<div id="ord-alert-danger" class="alert-danger alert-ord-notification" style="margin-top: 0px">'
    $.ajax({
      url: "/api/v3/feed_product_statuses/#{@get_ord_feed_product_statuses_site}",
      dataType: 'json',
      method: 'get',
      success: (data) =>
        if data.hasOwnProperty('data') && Object.keys(data.data).length > 0
          ord_statuses_manual_load  = ['Active', 'Failed', 'Error', 'Empty']
          redColor = '#a94442'
          greenColor = '#398339'
          yellowColor = '#dc9d00'
          padding_top = '2px';
          html_text='<div class="alert-gray alert-ord-notification" style="margin-top: 0px">'
          if data.data.hasOwnProperty('Active')
            html_text+= '<div style="color: '+greenColor+'; padding-top:'+padding_top+'">Active: '+data.data.Active+'</div>'
          if data.data.hasOwnProperty('Failed')
            html_text+= '<div style="color: '+redColor+'; padding-top:'+padding_top+'">Failed: '+data.data.Failed+'</div>'
          if data.data.hasOwnProperty('Error')
            html_text+= '<div style="color: '+redColor+'; padding-top: '+padding_top+'">Error: '+data.data.Error+'</div>'
          if data.data.hasOwnProperty('Empty')
            html_text+= '<div style="padding-top: '+padding_top+'">Empty: '+data.data.Empty+'</div>'
          $.each data.data, (key, item) ->
            if !ord_statuses_manual_load.includes(key)
              html_text+= '<div style="color: '+yellowColor+'; padding-top:'+padding_top+'">'+key+': '+item+'</div>'
          html_text+='</div>'
          @get_ord_feed_product_statuses_block.html html_text
        else
          @get_ord_feed_product_statuses_block.html error_html+__('sites.get-ord-feed-statuses.error')+'</div>'

        @get_ord_feed_product_statuses_block.html html_text
        @get_ord_feed_product_statuses_loading.css({display:'none'})
        @get_ord_feed_product_statuses.css({display:'block'})
      error: (jqXHR, textStatus, errorThrown) =>
        if jqXHR.hasOwnProperty('responseJSON') && jqXHR.responseJSON.hasOwnProperty('error') && jqXHR.responseJSON.error != null && jqXHR.responseJSON.error != 'null' && jqXHR.responseJSON.error.length > 0
          @get_ord_feed_product_statuses_block.html error_html+jqXHR.responseJSON.error+'</div>'
        else
          @get_ord_feed_product_statuses_block.html error_html+__('sites.get-ord-feed-statuses.error')+'</div>'
        @get_ord_feed_product_statuses_loading.css({display:'none'})
        @get_ord_feed_product_statuses.css({display:'block'})
    })
    return false

  analytics_auth: =>
    analytics_source = @analytics_source.val()
    action = if window.location.href.indexOf("/new") != -1 then 'new' else 'update'

    if action == 'new'
      @open_analytics_modal('', action)
      return false

    $.ajax({
      url: "/api/v3/user/analytics_auth_url?site_id=#{@analytics_site}&type=#{@analytics_method}&source=#{analytics_source}&callback_uri=" + window.location.href,
      dataType: 'json',
      method: 'get',
      success: (data) =>
        @open_analytics_modal(data.url, action)
      error: (jqXHR, textStatus, errorThrown) =>
          # console.error 'ajax error', errorThrown, jqXHR
    })
    return false

  open_analytics_modal: (url, action) =>
    modalSettings =
      title: __('sites.analytics.modal.title')
      body: if action != 'new' then __('sites.analytics.modal.info') else __('sites.analytics.modal.new')
      size: 'medium'
      buttons: if action != 'new' then [
        attr:
          class: "cr-forced-update btn btn-primary"
          type: "button"
        click: =>
          window.location.href = url
        text: __('sites.analytics.modal.continue')
      ] else [];

    INTENT.utils.Modal.show modalSettings

  get_json: =>
    unless @json
      json = @el.attr @s.ATTR_JSON
      @json = jQuery.parseJSON json

    return @json

  get_origin_values: =>
    unless @origin_values
      origin_values = @el.attr @s.ATTR_VALUES
      @origin_values = jQuery.parseJSON origin_values

    return @origin_values

  show_cpa_controls: =>
    unless @enable_cpa_controls
      enable_cpa_controls = @el.attr @s.ATTR_CPA_CONTROLS
      @enable_cpa_controls = jQuery.parseJSON enable_cpa_controls

    return @enable_cpa_controls

  get_last_id: =>
    unless @rules_container.find('tr').length
      return 0

    last_id = parseInt @rules_container.find('tr:last').attr @s.ATTR_RULE_ID
    return last_id + 1

  change_type: (e) =>
    self = $ e.currentTarget
    id = self.parents('tr').attr @s.ATTR_RULE_ID
    additional_container = self.parents('tr').find "[#{@s.ATTR_RULE_ADDITIONAL}]"
    json = @get_json()
    type = self.val()
    fields = json[type]['fields']
    fields_tpl = INTENT.templates.CrudSite.get_input_additional id, {}, fields
    additional_container.empty().append fields_tpl

  remove_item: (e) =>
    self = $ e.currentTarget
    self.parents("tr").remove()
    return false

  prevalidate_convertion_rules: =>
    core = @
    errors = []

    inputs_names = @rules_container.find "[#{@s.ATTR_RULE_NAME}]"
    inputs_names.removeClass @s.CLASS_ERROR
    inputs_names.each ->
      self = $ @
      val = self.val()

      if !val.match(/^[^а-яА-Я\s]*$/g) && !self.is('.disabled')
        self.addClass core.s.CLASS_ERROR
        errors.push self
      if val.length <= 0
        self.addClass core.s.CLASS_ERROR
        errors.push self

    max_conversions_numbers = @rules_container.find "[#{@s.ATTR_RULE_MAX_CONVERSIONS_NUMBER}]"
    max_conversions_numbers.removeClass @s.CLASS_ERROR
    max_conversions_numbers.each ->
      self = $ @
      val = self.val()

      if(val && parseInt(val) < 0)
        self.addClass core.s.CLASS_ERROR
        errors.push self

    additional_fields = @rules_container.find "[#{@s.ATTR_RULE_ADDITIONAL_FIELD}]"
    additional_fields.removeClass @s.CLASS_ERROR
    additional_fields.each ->
      self = $ @
      val = self.val()
      if val.length <= 0 && !self.is("[allow-empty]")
        self.addClass core.s.CLASS_ERROR
        errors.push self

    if (errors.length > 0)
      setTimeout (=>
        core.btnSubmit.hideLoader('disabled')
      ), 400

    return errors.length == 0

  init_exist: =>
    @rules_container.empty()
    exists_rules = @get_origin_values()
    for ex_index, ex_rule of exists_rules
      id = @get_last_id()
      item = INTENT.templates.CrudSite.get_conversion_rule id, @get_json(), ex_rule, @show_cpa_controls()
      @rules_container.append item

    init_select2()
    init_switcher()

  add_item: =>
    id = @get_last_id()
    item = INTENT.templates.CrudSite.get_conversion_rule id, @get_json(), null, @show_cpa_controls()
    @rules_container.append item
    init_select2()
    init_switcher()
    return false
